import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { AccessDeniedError, ForbiddenOrganizationError, MyAccountService, OrganizationNotFoundError } from './my-account.service';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {

  constructor(
    private _router: Router,
    private _myAccountService: MyAccountService,
    private _ngZone: NgZone,
  ) { }

  handleError(error: any): void {
    // Refine error remapping to extract original error (common with Promise rejections, HttpClient, RxJS, etc.)
    const err = error?.rejection || error?.originalError || error;
    console.error('Global unhandled error:', err);

    // TODO - Prevent infinite loops on expression changes
    // if (error?.message?.includes('ExpressionChangedAfterItHasBeenCheckedError')) {
    //   console.warn('Ignored known dev error:', error);
    //   return;
    // }

    if (err instanceof AccessDeniedError) {
      this._ngZone.run(() => {
        console.log('Redirecting to access denied page');
        this._router.navigate(['access-denied']);
      });
      return;
    }
    if (err instanceof ForbiddenOrganizationError) {
      this._ngZone.run(() => {
        console.log('Redirecting to select organization – forbidden', err.organizationCode.toUpperCase());
        this._myAccountService.clearOrganizationDirectorySelection();
        this._router.navigate(['organizations']);
      });
      return;
    }
    if (err instanceof OrganizationNotFoundError) {
      this._ngZone.run(() => {
        console.log("Cannot find the organization with code:", err.organizationCode.toUpperCase())
        console.log("Redirecting to select organization page");
        this._myAccountService.clearOrganizationDirectorySelection();
        this._router.navigate(['organizations']);
      });
      return;
    }
    if (err instanceof HttpErrorResponse) {
      this.handleHttpError(err);
      return;
    }
    // TODO - maybe use sackbars for the following messages instead of just logging to the console
    if (err?.name === 'TimeoutError') {
      console.log('Request timed out. Please try again.');
      return;
    }
    if (navigator.onLine === false) {
      console.log('No internet connection.');
      return;
    }

    console.log('Something went wrong. We\'re looking into it.');
    // Re-throw so the error still appears in console
    // TODO - Make optional in prod
    throw err;
  }

  // This method would run as a fallback to what ever is not caught by the error handling HTTP interceptor.
  private handleHttpError(error: HttpErrorResponse): void {
    // Add more cases here
    return;
  }
}
